import { Container } from "./styles";

export function AreaConteudos() {
  const url =
    "https://axsenergia.sharepoint.com/:f:/s/marketing/EqKHffVUkVhEsCjrPMrTR3cBPKoaeRMXV4nf29As92ierA?e=i8PSCv";
  return (
    <Container>
      <a target="_blank" href={url} rel="noreferrer">
        MATERIAIS DE APOIO
      </a>
    </Container>
  );
}
